<style lang="less" type="text/less" scoped>
    .form{
        padding-top:50px;
    }
    h1{
        color:green;
        line-height:1.5em;
        font-weight:normal;
        font-size:15px;
    }
    .row{
        text-align:center;
        margin:0 20px;
    }
    .the-input{
        display:inline-block;
    }
    .btn{
        background:green;
        color:#fff;
        width:200px;
    }
</style>
<template>
    <div>
        <div v-show="isDoingAutoLogin" style="text-align:center;">自动登录中...</div>
        <form class="form" @submit.prevent="submit();" v-show="!isDoingAutoLogin">
            <div class="row">
                <my-input class="the-input" ref="username" v-model="username" wide required no-required-sign blur-check placeholder="手机号"></my-input>
            </div>
            <div class="row">
                <my-input class="the-input" ref="password" type="password" wide v-model="password" required no-required-sign blur-check placeholder="密码"></my-input>
            </div>
            <div class="row" style="margin-top:20px;">
                <button class="btn wide" @click="submit();">登录{{ loading ? '...' : ''}}</button>
            </div>
            <div class="row" style="margin-top:20px;text-align:left;">
                <a href="javascript:void(0);" @click="$router.go({name:'register'})">注册</a>
            </div>
            <!--<div class="row" v-show="isReliao" style="margin-top:20px;">-->
            <!--<button class="btn wide" @click="magic(0)">自动登录0</button>-->
            <!--</div>-->
            <!--<div class="row" v-show="isReliao">-->
            <!--<button class="btn wide" @click="magic(1)">自动登录1</button>-->
            <!--</div>-->
            <div class="row" style="margin-top:100px;text-align:center;">
                <span style="margin:0 -50px;font-size:10px;color:#ccc;">版本: {{rev}}</span>
            </div>
        </form>
    </div>
</template>
<script type="text/ecmascript-6">

    import user from '../lib/UserService';
    import event from '../lib/event';
    import util from '../lib/util';
    import config from '../lib/config';
    import preload from '../lib/preload';

    module.exports = {
        data: function () {
            return {
                isDoingAutoLogin:false,
                username:'',
                password:'',
                loading:false,
                isReliao:util.isReliao(),
                rev:config.rev
            }
        },
        methods: {
            checkValid:function () {
                var isValid = true;
                $.each(this.$refs,function (k,v) {
                    if(v.checkValid && !v.checkValid()){
                        isValid = false;
                    }
                })
                return isValid;
            },
            submit:function () {
                var vm = this;
                if(vm.loading)return;
                if(this.checkValid()){
                    vm.loading = true;
                    user.loginWithPassword(this.username,this.password).then(function () {
                        return vm.onLoginSuccess();
                    }).catch(function (e) {
                        return vm.onLoginError(e);
                    });
                }
            },
            onLoginSuccess:function () {
                var vm = this;
                var url = vm.$route.query.callback;
                vm.loading = false;
                if( /^\/login/.test(url) ){ // url start with /login
                    $router.replace('/');
                }else{
                    $router.replace(url||'/');
                }
                return null;
            },
            onLoginError:function (e) {
                var vm = this;
                vm.loading = false;
                if(e.code == 'A00001'){
                    event.emit('toast','用户名或密码错误');
                }
                if(e.errorMsg){
                    event.emit('toast',e.errorMsg);
                }
            },
            tryAutoLogin(){
                this.isDoingAutoLogin = true;
                var vm = this;
                var code = this.$route.query.code;
                user.loginWithWeChatCode(code).then(function () {
                    vm.isDoingAutoLogin = false;
                    return vm.onLoginSuccess();
                }).catch(function (e) {
                    vm.isDoingAutoLogin = false;
                    return vm.onLoginError(e);
                });
            }
        },
        components: {
            myInput:require('../components/form/Input.vue')
        },
        mounted: function () {
            var noAutoLogin = this.$route.query.auto=='0';
            if(this.$route.query.code && !noAutoLogin){
                this.tryAutoLogin();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// login.vue?11d2e7cd